<template>
    <CreateReminder></CreateReminder>
    <DisplayReminders></DisplayReminders>
</template>

<script>
import CreateReminder from '@/components/reminders/CreateReminder.vue';
import DisplayReminders from '@/components/reminders/DisplayReminders.vue';

export default {
    components: {
        CreateReminder,
        DisplayReminders
    }
}
</script>